// // src/components/Programs/ProgramCTABanner.jsx

// const ProgramCTABanner = ({ data }) => {
//   if (!data) return null;

//   const { heading, description, image, imageAlt, primaryButton, secondaryButton } = data;

//   return (
//     <section className="w-full py-4 md:py-8 bg-white">
//       <div className="max-w-6xl mx-auto px-4">
//         <div className="relative ava-card-bg rounded-md overflow-visible grid grid-cols-1 md:grid-cols-[1.65fr_1fr] items-center min-h-[260px]">

//           {/* Left Content */}
//           <div className="px-6 py-8 md:px-24 md:py-10 md:pr-2">
//             <h6 className="ava-heading-md">
//               {heading}
//             </h6>
//             <p className=" mt-4 ava-text-body">
//               {description}
//             </p>
//             <div className="flex flex-wrap gap-4 mt-6">
//               {primaryButton && (
//                 <button
//                   type="button"
//                   onClick={() => primaryButton.href && (window.location.href = primaryButton.href)}
//                   className="btn-primary"
//                 >
//                   {primaryButton.label}
//                 </button>
//               )}
//               {secondaryButton && (
//                 <button
//                   type="button"
//                   onClick={() => secondaryButton.href && (window.location.href = secondaryButton.href)}
//                   // className="h-11 px-6 rounded-md bg-[#dfe4f3] text-[var(--primary-color)] text-sm md:text-base font-medium"
//                   className="btn-transparent"
//                   // className="btn-outline color-[var(--primary-color)]"
//                 >
//                   {secondaryButton.label}
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* Right Image */}
//           {/* <div className="hidden md:block absolute right-[-65px] w-[475px] h-[220px]"> */}
//           <div className="w-full h-48 md:absolute md:right-[-65px] md:w-[475px] md:h-[220px]">
//             <img
//               src={image}
//               alt={imageAlt || ""}
//               className="w-full h-full object-cover shadow-md"
//               loading="lazy"
//             />
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default ProgramCTABanner;
// src/components/Programs/ProgramCTABanner.jsx

const ProgramCTABanner = ({ data }) => {
  if (!data) return null;

  const { heading, description, image, imageAlt, primaryButton, secondaryButton } = data;

  return (
    <section className="w-full py-8 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="ava-card-bg rounded-xl overflow-hidden md:overflow-visible relative grid grid-cols-1 md:grid-cols-[1.6fr_1fr] items-center min-h-[260px]">

          {/* Left Content */}
          <div className="px-8 py-10 md:px-16 md:py-10 z-10 relative">
            <h6 className="ava-heading-md">{heading}</h6>
            <p className="mt-4 ava-text-body">{description}</p>
            <div className="flex flex-wrap gap-3 mt-6">
              {primaryButton && (
                <button
                  type="button"
                  onClick={() => primaryButton.href && (window.location.href = primaryButton.href)}
                  className="btn-primary"
                >
                  {primaryButton.label}
                </button>
              )}
              {secondaryButton && (
                <button
                  type="button"
                  onClick={() => secondaryButton.href && (window.location.href = secondaryButton.href)}
                  className="btn-transparent"
                >
                  {secondaryButton.label}
                </button>
              )}
            </div>
          </div>

          {/* Right Image */}
          <div className="
            w-full h-56 overflow-hidden
            md:absolute md:right-[-60px] md:top-1/2 md:-translate-y-1/2
            md:w-[420px] md:h-[240px] ava-radius-md md:shadow-xl
          ">
            {/* Fade blend on desktop */}
            <div className="hidden md:block absolute left-0 inset-y-0 w-14  " />
            {/* bg-gradient-to-r from-[var(--card-bg,#f3f0fb)] to-transparent z-10 */}
            <img
              src={image}
              alt={imageAlt || ""}
              className="w-full  h-full ava-card-image  object-cover object-top ava-radius-md"
              loading="lazy"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default ProgramCTABanner;